import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Invite from "./pages/Invite";
import Dashboard from "./pages/Dashboard";
import Workspaces from "./pages/Workspaces";
import Targets from "./pages/Targets";
import Scans from "./pages/Scans";
import Findings from "./pages/Findings";
import Reports from "./pages/Reports";
import ReportView from "./pages/ReportView";
import Audit from "./pages/Audit";
import Settings from "./pages/Settings";
import { Toaster } from "./components/ui/sonner";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#020817] text-slate-400">
        <div className="animate-pulse">Securing session…</div>
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/invite/:token" element={<Invite />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/workspaces" element={<Protected><Workspaces /></Protected>} />
            <Route path="/targets" element={<Protected><Targets /></Protected>} />
            <Route path="/scans" element={<Protected><Scans /></Protected>} />
            <Route path="/findings" element={<Protected><Findings /></Protected>} />
            <Route path="/reports" element={<Protected><Reports /></Protected>} />
            <Route path="/reports/:id" element={<Protected><ReportView /></Protected>} />
            <Route path="/audit" element={<Protected><Audit /></Protected>} />
            <Route path="/settings" element={<Protected><Settings /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" theme="dark" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
